import { render, staticRenderFns } from "./CafeLayout.vue?vue&type=template&id=6ea2af0e&"
import script from "./CafeLayout.vue?vue&type=script&lang=js&"
export * from "./CafeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports